export enum SalaryRuleType {
Basic,
Main,
Other,
}
